import React from "react";
import classnames from "classnames";

import DropDownVariantIconButton from "./DropDownVariantIconButton";
import DropDownVariantButton from "./DropDownVariantButton";

import EgwWebFont from "../../assets/EgwWebFont";
import { BUTTON_FONT_FAMILY } from "../Button/Button.constants";
import { getControlPanelIcons, renderIcons } from "../../utils/panel/Panel.utils";
import { remToPx } from "@/shared/utils/viewmode";
import { handleReactSlot } from "@/shared/utils/react";
import { ThreeDotsProps } from "@/shared/components/DropDown/ThreeDots.constants";

import styles from "./ThreeDots.module.scss";

const BUTTON_PROPS_TEXT_MODE = {
  fontFamily: BUTTON_FONT_FAMILY.bebas,
};

const ThreeDots = ({
  className,
  icons,
  widthAvailable,
  iconTitle,
  isApplyDefault3DotsStylesToPopup = true,
  isShowIconInTextMode,
  isCollapsed,
  isDotsPositionAfter,
  classNamePopupContent,
  btnThreeDotsWidth,
  idButton,
  idPopup,
  isMobile, 
  textMode,
  onShow,
  children,
}) => {
  const widthBtn = btnThreeDotsWidth ?? remToPx(2.4);

  let hiddenIcons, visibleIcons;

  if (icons) {
    const result = getControlPanelIcons(
      icons,
      {
        widthBtnThreeDots: widthBtn,
        isCollapsed: isCollapsed ?? (isMobile || textMode),
        parentWidth: widthAvailable,
      }
    );

    hiddenIcons = result.hiddenIcons;
    visibleIcons = result.visibleIcons;
  }

  const buttonPropsFinal = textMode ? {
    ...BUTTON_PROPS_TEXT_MODE,
    id: idButton,
  }  : (idButton ? { id: idButton } : undefined);

  let jsxDots;

  const showTextButton = textMode && !isMobile && !isShowIconInTextMode;

  if (
    children
    || (
      hiddenIcons
      && hiddenIcons.length
      && (
        hiddenIcons.length > 1
        || hiddenIcons[0].width > widthBtn
        || showTextButton
      )
    )
  ) {
    const popupPropsFinal = {
      beautyGapHorizontal: 0,
      beautyGapVertical: 0,
      renderViewClassName: classnames(classNamePopupContent, {
        [styles["labels-mode"]]: textMode,
        [styles["popup-content-default"]]: isApplyDefault3DotsStylesToPopup,
      }),
      id: idPopup,
    };

    const jsxChildren = ({ hide }) => (
      children
        ? handleReactSlot(children, { hide })
        : renderIcons(hiddenIcons, hide)
    );

    if (showTextButton) {
      jsxDots = (
        <DropDownVariantButton
          className={className}
          onShow={onShow}
          label={iconTitle}
          buttonProps={buttonPropsFinal}
          popupProps={popupPropsFinal}
        >
          {jsxChildren}
        </DropDownVariantButton>
      );
    } else {
      jsxDots = (
        <DropDownVariantIconButton
          className={className}
          showIcon
          isPopupCoversButtonByDefault={!isMobile}
          icon={EgwWebFont["dots-vertical"]}
          iconTitle={iconTitle}
          buttonProps={buttonPropsFinal}
          popupProps={popupPropsFinal}
        >
          {jsxChildren}
        </DropDownVariantIconButton>
      );
    }
  }

  return (
    <>
      {!isDotsPositionAfter && jsxDots}
      {visibleIcons && renderIcons(visibleIcons)}
      {isDotsPositionAfter && jsxDots}
    </>
  );
};

ThreeDots.defaultProps = {
  withToggleDelayRestriction: true,
};

ThreeDots.propTypes = ThreeDotsProps;

export default ThreeDots;
